import { Button, Container } from '../../components';
import styles from './nft-help.module.css';

export default function NFTHelp() {
  return (
    <section className={styles.section}>
      <Container variant="container_medium">
        <div className={styles.inner}>
          <div className={styles.block}>
            <div className={styles.title}>
              Need help making NFT marketplace?
            </div>
            <div className={styles.text}>
              We can create the ideal solution for you and offer you a team of
              specialists with expertise in DeFi
            </div>
          </div>
          <span className={styles.button}>
            <Button tag="a" href="/contact" appearance="nft">
              Get a consultation
            </Button>
          </span>
        </div>
      </Container>
    </section>
  );
}
